<template>
  <v-container grid-list-md text-xs-center fluid>
    <v-row row wrap>
      <v-text-field
        append-icon="search"
        v-model="searchText"
        :placeholder="resx.labels.searchVehicles"
      >
      </v-text-field>
    </v-row>
    <v-row row wrap>
      <v-list
        style="width: 100%"
        two-line
        v-if="filteredVehicles && filteredVehicles.length > 0"
      >
        <template v-for="(vehicle, index) in filteredVehicles">
          <v-list-group
            :sub-group="$vuetify.breakpoint.smAndUp"
            :no-action="$vuetify.breakpoint.smAndUp"
            :key="vehicle._id"
            :value="false"
            v-if="
              $store.state.auth.user.roles[0] !=
                $store.state.constants.roles.SECURITY
            "
          >
            <v-list-item slot="activator">
              <v-list-item-action>
                <v-tab>
                  <v-icon color="primary">commute</v-icon>
                  <v-badge overlap color="error" v-if="countInvalidObligations(vehicle) > 0">
                    <span slot="badge">{{
                      countInvalidObligations(vehicle) }}
                    </span>
                  </v-badge>
                </v-tab>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  <text-highlight :queries="searchText">{{
                    vehicle.description
                  }}</text-highlight>
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ `${resx.labels.domain}: `
                  }}<text-highlight :queries="searchText">{{
                    vehicle.uniqueIdentifier
                  }}</text-highlight>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action v-if="$vuetify.breakpoint.smAndUp">
                <v-btn
                  icon
                  text
                  color="primary"
                  @click.stop="
                    $emit('viewComment', {
                      title: vehicle.description,
                      value: vehicle.comments
                    })
                  "
                  :disabled="!vehicle.comments"
                >
                  <v-icon>comment</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
            <contractor-obligations-details
              :obligations="getVehicleObligations(vehicle)"
              @viewComment="$emit('viewComment', $event)"
            ></contractor-obligations-details>
          </v-list-group>
          <v-list-item :key="vehicle._id" v-else>
            <v-list-item-action>
              <v-icon :color="isDelayed(vehicle._id) ? 'error' : 'green'"
                >commute</v-icon
              >
            </v-list-item-action>
            <v-list-item-content style="max-width: 220px;">
              <v-list-item-title>
                <text-highlight :queries="searchText">{{
                  vehicle.description
                }}</text-highlight>
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ `${resx.labels.domain}: `
                }}<text-highlight :queries="searchText">{{
                  vehicle.uniqueIdentifier
                }}</text-highlight>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action v-if="visit">
              <v-checkbox
                v-if="isIncluded(vehicle._id) || isAlreadyIn(vehicle._id)"
                color="indigo"
                hide-details
                light
                input-value="true"
                disabled
              ></v-checkbox>
              <v-checkbox
                v-else
                color="indigo"
                hide-details
                light
                disabled
              ></v-checkbox>
            </v-list-item-action>
            <v-list-item-action v-else>
              <v-checkbox
                v-if="isAlreadyIn(vehicle._id)"
                color="indigo"
                hide-details
                light
                input-value="true"
                disabled
              ></v-checkbox>
              <v-checkbox
                v-if="!isAlreadyIn(vehicle._id)"
                color="indigo"
                hide-details
                light
                v-model="checkedVehicles[index]"
                :value="vehicle"
                @change="updateVehicles(vehicle)"
              ></v-checkbox>
            </v-list-item-action>
            <v-list-item-action>
              <v-btn
                icon
                text
                color="primary"
                @click.stop="
                  $emit('viewComment', {
                    title: vehicle.description,
                    value: vehicle.comments
                  })
                "
                :disabled="!vehicle.comments"
              >
                <v-icon>comment</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </template>
      </v-list>
      <v-alert color="primary" icon="info" v-else :value="true">
        {{ resx.messages.noDataAvailable }}
      </v-alert>
    </v-row>
  </v-container>
</template>

<script>
"use strict";

import contractorObligationsDetails from "./contractor-obligations-details.view.vue";
import TextHighlight from "vue-text-highlight";

export default {
  name: "contractorObligationsVehiclesDetails",
  components: {
    contractorObligationsDetails,
    TextHighlight
  },
  computed: {
    filteredVehicles() {
      const regexp = new RegExp(this.searchText, "i");
      return this.vehicles.filter(v => {
        return (
          (!this.visit || (this.visit && this.isIncluded(v._id))) &&
          (regexp.test(v.description) || regexp.test(v.uniqueIdentifier))
        );
      });
    }
  },
  data() {
    return {
      searchText: "",
      checkedVehicles: []
    };
  },
  methods: {
    isIncluded(id) {
      return this.visit.vehicles.includes(String(id));
    },
    isAlreadyIn(id) {
      return this.alreadyIn.includes(String(id));
    },
    isAuthorized() {
      let isAuthorized = true;
      for (let index in this.checkedVehicles) {
        if (this.checkedVehicles[index] != null) {
          isAuthorized =
            isAuthorized && !this.isDelayed(this.checkedVehicles[index]._id);
        }
      }
      return isAuthorized;
    },
    countInvalidObligations(vehicle) {
      const delayedObligations = this.getVehicleObligations(vehicle).filter(
        o => o.status == this.$store.state.constants.OBLIGATIONS.STATUS.DELAYED 
      );
      return delayedObligations.length;
    },
    getVehicleObligations(vehicle) {
      return this.obligations.filter(o => o.referenceId == vehicle._id);
    },
    isDelayed(id) {
      return this.delayedObligations && this.delayedObligations.length > 0
        ? this.delayedObligations.filter(o => o.referenceId == id).length > 0
        : false;
    },
    updateVehicles(vehicle) {
      this.isAuthorized();
      this.$emit("updateVehicles", vehicle, this.isAuthorized());
    }
  },
  props: {
    vehicles: { type: Array },
    obligations: { type: Array },
    delayedObligations: { type: Array },
    alreadyIn: { type: Array },
    visit: { type: Object }
  }
};
</script>
